import { useQuery } from "@tanstack/react-query";
import axiosManager from "services/axiosManager";

const useGetNotices = () => {
    const {
        data: notices,
        error,
        isLoading,
    } = useQuery({
        queryKey: ["notices"],
        queryFn: () =>
            axiosManager.get$("/support/notices").then((res) => res.data),
    });

    return { notices, error, isLoading };
};

export default useGetNotices;
